// import store from '../store';
import {
    PIPE_TYPE_SOIL_TIGHT_ID, PIPE_TYPE_SOIL_TIGHT_NAME,
    PIPE_TYPE_SOIL_TIGHT_PERFORATED_ID, PIPE_TYPE_SOIL_TIGHT_PERFORATED_NAME,
    // PIPE_TYPE_WATER_TIGHT,
    PIPE_TYPE_WATER_TIGHT_ID, PIPE_TYPE_WATER_TIGHT_NAME,
    PIPE_PART_MANIFOLD_T, PIPE_PART_CORNER,
    HDPE_N12_ID,
    PIPE_DETENTION_SYSTEM_ID, PIPE_DETENTION_SYSTEM_NAME,
    PIPE_CUSTOMF_FITTING_ID, PIPE_CUSTOMF_FITTING_NAME,
    PIPE_LINE_LAYOUT_ID, PIPE_LINE_LAYOUT_NAME,
    PIPE_RETENTION_SYSTEM_ID, PIPE_RETENTION_SYSTEM_NAME,
} from "./types";
import { getScaledPixels } from "./calculations";
import PipeSelectors from "../lib/pipe-selectors";

const PIPE_NOMINAL_DIAMETER_TYPE = {
    ACCESSORY: 1,
    STICK: 2,
    FITTING: 4,
};

export const PipeFlowDirection = {
    TopLeftToBottomLeft: "TopLeftToBottomLeft",
    TopLeftToBottomRight: "TopLeftToBottomRight",
  TopRightToBottomLeft: "TopRightToBottomLeft",
  TopRightToBottomRight: "TopRightToBottomRight",
  BottomLeftToTopLeft: "BottomLeftToTopLeft",
  BottomLeftToTopRight: "BottomLeftToTopRight",
  BottomRightToTopLeft: "BottomRightToTopLeft",
  BottomRightToTopRight: "BottomRightToTopRight"
};

const ALL_PIPE_NOMINAL_DIAMETER_TYPES =
  PIPE_NOMINAL_DIAMETER_TYPE.ACCESSORY | PIPE_NOMINAL_DIAMETER_TYPE.STICK | PIPE_NOMINAL_DIAMETER_TYPE.FITTING;

class PipeNominalDiameter{
    constructor( pipeND, pipeID, pipeOD, pitch,
                 spigotLength = null, lengthMax = null,
                 legLengthPlainEnd = null, legLengthWeldedBellEnd = null, legLengthGasketEnd = null,
                 excavationLimit = null,
                 manifoldBendPlainEndVolume = null,
                 manifoldBendWeldedBellEndVolume = null,
                 manifoldBendGasketEndVolume = null,
                 manifoldSingleTeePlainEndVolume = null,
                 manifoldDoubleTeePlainEndVolume = null,
                 manifoldTripleTeePlainEndVolume = null,
                 manifoldSingleTeeWeldedBellEndVolume = null,
                 manifoldDoubleTeeWeldedBellEndVolume = null,
                 manifoldTripleTeeWeldedBellEndVolume = null,
                 manifoldSingleTeeGasketEndVolume = null,
                 manifoldDoubleTeeGasketEndVolume = null,
                 manifoldTripleTeeGasketEndVolume = null,
                 isType = PIPE_NOMINAL_DIAMETER_TYPE.ACCESSORY, isDefault = false, perimeterOffset = {
            default: null,
            min: null,
            max: null,
        },
                 widthMin = null,
                 manifoldBendPlainEndVolumeOD = null,
                 manifoldSingleTeePlainEndVolumeOD = null,
                 manifoldDoubleTeePlainEndVolumeOD = null,
                 manifoldTripleTeePlainEndVolumeOD = null,
    ) {
        this._pipeND = new InchUtility(pipeND);
        this._pipeID = new InchUtility(pipeID);
        this._pipeOD = new InchUtility(pipeOD);
        this._pitch = new InchUtility(pitch);
        this._spigotLength = new InchUtility(spigotLength);
        this._lengthMax = new InchUtility(lengthMax);
        this._legLengthPlainEnd = new InchUtility(legLengthPlainEnd);
        this._legLengthWeldedBellEnd = new InchUtility(legLengthWeldedBellEnd);
        this._legLengthGasketEnd = new InchUtility(legLengthGasketEnd);
        this._excavationLimit = new InchUtility(excavationLimit);
        this._manifoldBendPlainEndVolume = manifoldBendPlainEndVolume / 1728;
        this._manifoldBendWeldedBellEndVolume = manifoldBendWeldedBellEndVolume / 1728;
        this._manifoldBendGasketEndVolume = manifoldBendGasketEndVolume / 1728;
        this._manifoldSingleTeePlainEndVolume = manifoldSingleTeePlainEndVolume / 1728;
        this._manifoldDoubleTeePlainEndVolume = manifoldDoubleTeePlainEndVolume / 1728;
        this._manifoldTripleTeePlainEndVolume = manifoldTripleTeePlainEndVolume === null ?
            null : manifoldTripleTeePlainEndVolume / 1728;
        this._manifoldSingleTeeWeldedBellEndVolume = manifoldSingleTeeWeldedBellEndVolume / 1728;
        this._manifoldDoubleTeeWeldedBellEndVolume = manifoldDoubleTeeWeldedBellEndVolume / 1728;
        this._manifoldTripleTeeWeldedBellEndVolume = manifoldTripleTeeWeldedBellEndVolume === null ?
            null : manifoldTripleTeeWeldedBellEndVolume / 1728;
        this._manifoldSingleTeeGasketEndVolume = manifoldSingleTeeGasketEndVolume / 1728;
        this._manifoldDoubleTeeGasketEndVolume = manifoldDoubleTeeGasketEndVolume / 1728;
        this._manifoldTripleTeeGasketEndVolume = manifoldTripleTeeGasketEndVolume === null ?
            null : manifoldTripleTeeGasketEndVolume / 1728;
        this._isType = isType;
        this._isDefault = isDefault;
        this._perimeterOffset = perimeterOffset;
        this._widthMin = widthMin;
        this._manifoldBendPlainEndVolumeOD = manifoldBendPlainEndVolumeOD === null ? null : manifoldBendPlainEndVolumeOD / 1728;
        this._manifoldSingleTeePlainEndVolumeOD = manifoldSingleTeePlainEndVolumeOD === null ? null : manifoldSingleTeePlainEndVolumeOD / 1728;
        this._manifoldDoubleTeePlainEndVolumeOD = manifoldDoubleTeePlainEndVolumeOD === null ? null : manifoldDoubleTeePlainEndVolumeOD / 1728;
        this._manifoldTripleTeePlainEndVolumeOD = manifoldTripleTeePlainEndVolumeOD === null ? null : manifoldTripleTeePlainEndVolumeOD / 1728;
    }

    get pipeStickUnitAreaOD() {
        return Math.pow(this.pipeOD.ft / 2, 2) * Math.PI;
    }

    get rawPipeND() {
        return this.pipeND.in;
    }

    get pipeND() {
        return this._pipeND;
    }

    get pipeID() {
        return this._pipeID;
    }

    get excavationLimit() {
        return this._excavationLimit;
    }

    get width() {
        return this.pipeOD;
    }

    get pipeOD() {
        return this._pipeOD;
    }

    get length() {
    return this.pitch;
  }

  get pipeStickToPitchRatio() {
    return this.spigotLength.in / this.pitch.in;
  }

  get pitch() {
    return this._pitch;
  }

  get spigotLength() {
    return this._spigotLength;
  }

  get lengthMin() {
    if (this.rawPipeND < 36) {
      return this.pipeND;
    }

    return new InchUtility(36);
  }

  get lengthMax() {
    return this._lengthMax;
  }

  get legLengthPlainEnd() {
    return this._legLengthPlainEnd;
  }

    get legLengthWeldedBellEnd() {
        return this._legLengthWeldedBellEnd;
    }

    get legLengthGasketEnd() {
        return this._legLengthGasketEnd;
    }

    get pipeStickUnitArea() {
        return Math.pow(this.pipeID.ft / 2, 2) * Math.PI;
    }

    get horizontalRowHeight() {
        return new InchUtility(this._legLengthPlainEnd.in + ( this._pipeOD.in / 2 ));
    }

    get manifoldBendPlainEndVolumeOD() {
        return this._manifoldBendPlainEndVolumeOD;
    }

    get manifoldBendPlainEndVolume() {
        return this._manifoldBendPlainEndVolume;
    }

    get manifoldBendWeldedBellEndVolume() {
        return this._manifoldBendWeldedBellEndVolume;
    }

    get manifoldBendGasketEndVolume() {
        return this._manifoldBendGasketEndVolume;
    }

    get manifoldSingleTeePlainEndVolumeOD() {
        return this._manifoldSingleTeePlainEndVolumeOD;
    }

    get manifoldSingleTeePlainEndVolume() {
        return this._manifoldSingleTeePlainEndVolume;
    }

    get manifoldDoubleTeePlainEndVolume() {
        return this._manifoldDoubleTeePlainEndVolume;
    }

    get manifoldTripleTeePlainEndVolume() {
        return this._manifoldTripleTeePlainEndVolume;
    }

    get manifoldSingleTeeWeldedBellEndVolume() {
        return this._manifoldSingleTeeWeldedBellEndVolume;
    }

    get manifoldDoubleTeeWeldedBellEndVolume() {
        return this._manifoldDoubleTeeWeldedBellEndVolume;
    }

    get manifoldTripleTeeWeldedBellEndVolume() {
        return this._manifoldTripleTeeWeldedBellEndVolume;
    }

    get manifoldSingleTeeGasketEndVolume() {
        return this._manifoldSingleTeeGasketEndVolume;
    }

    get manifoldDoubleTeeGasketEndVolume() {
        return this._manifoldDoubleTeeGasketEndVolume;
    }

    get manifoldTripleTeeGasketEndVolume() {
        return this._manifoldTripleTeeGasketEndVolume;
    }

    get isAccessory() {
        return this._isType & PIPE_NOMINAL_DIAMETER_TYPE.ACCESSORY;
    }

    get isStick() {
        return this._isType & PIPE_NOMINAL_DIAMETER_TYPE.STICK;
    }

    get isFitting() {
        return this._isType & PIPE_NOMINAL_DIAMETER_TYPE.FITTING;
    }

    get isDefault() {
        return this._isDefault;
    }

    get perimeterOffset() {
        return this._perimeterOffset;
    }

    get widthMin() {
        const { stonePerimeterOffset } = PipeSelectors;
        this._widthMin = this.pipeOD.in + ( stonePerimeterOffset.in * 2 );
        return this._widthMin;
    }

    get manifoldDoubleTeePlainEndVolumeOD() {
        return this._manifoldDoubleTeePlainEndVolumeOD;
    }

    get manifoldTripleTeePlainEndVolumeOD() {
        return this._manifoldTripleTeePlainEndVolumeOD;
    }

    getPipeRowVolume( lengthActual ) {
        return lengthActual * this.pipeStickUnitArea;
    }

    getPipeRowVolumeOD( lengthActual ) {
        return lengthActual * this.pipeStickUnitAreaOD;
    }

    getManifoldBendVolume( pipeFitting, numberOfBends, useOD ) {
        if (pipeFitting.id === PIPE_TYPE_SOIL_TIGHT_PERFORATED_ID && useOD) {
            return numberOfBends * ( this.manifoldBendPlainEndVolumeOD * 2 );
        } else if (pipeFitting.id === PIPE_TYPE_SOIL_TIGHT_ID || pipeFitting.id === PIPE_TYPE_SOIL_TIGHT_PERFORATED_ID) {
            return numberOfBends * ( this.manifoldBendPlainEndVolume * 2 );
        }

        // water-tight
        return numberOfBends * ( this.manifoldBendWeldedBellEndVolume + this.manifoldBendGasketEndVolume );
    }

    getManifoldTeeVolume( pipeFitting, numberOfTees, useOD ) {
        const {
            manifoldSingleTeeVolume,
            manifoldDoubleTeeVolume,
            manifoldTripleTeeVolume,
        } = ( () => {
            if (pipeFitting.id === PIPE_TYPE_SOIL_TIGHT_PERFORATED_ID && useOD) {
                const {
                    manifoldSingleTeePlainEndVolumeOD,
                    manifoldDoubleTeePlainEndVolumeOD,
                    manifoldTripleTeePlainEndVolumeOD,
                } = this;

                return {
                    manifoldSingleTeeVolume: manifoldSingleTeePlainEndVolumeOD * 2,
                    manifoldDoubleTeeVolume: manifoldDoubleTeePlainEndVolumeOD * 2,
                    manifoldTripleTeeVolume: manifoldTripleTeePlainEndVolumeOD * 2,
                };
            } else if (pipeFitting.id === PIPE_TYPE_SOIL_TIGHT_ID || pipeFitting.id === PIPE_TYPE_SOIL_TIGHT_PERFORATED_ID) {
                const {
                    manifoldSingleTeePlainEndVolume,
                    manifoldDoubleTeePlainEndVolume,
                    manifoldTripleTeePlainEndVolume,
                } = this;

                return {
                    manifoldSingleTeeVolume: manifoldSingleTeePlainEndVolume * 2,
                    manifoldDoubleTeeVolume: manifoldDoubleTeePlainEndVolume * 2,
                    manifoldTripleTeeVolume: manifoldTripleTeePlainEndVolume * 2,
                };
            }

            // water-tight
            const {
                manifoldSingleTeeWeldedBellEndVolume,
                manifoldDoubleTeeWeldedBellEndVolume,
                manifoldTripleTeeWeldedBellEndVolume,
                manifoldSingleTeeGasketEndVolume,
                manifoldDoubleTeeGasketEndVolume,
                manifoldTripleTeeGasketEndVolume,
            } = this;

            return {
                manifoldSingleTeeVolume: manifoldSingleTeeWeldedBellEndVolume + manifoldSingleTeeGasketEndVolume,
                manifoldDoubleTeeVolume: manifoldDoubleTeeWeldedBellEndVolume + manifoldDoubleTeeGasketEndVolume,
                manifoldTripleTeeVolume: manifoldTripleTeeWeldedBellEndVolume + manifoldTripleTeeGasketEndVolume,
            };
        })();

    let tripleTees = 0;

    if (manifoldTripleTeeVolume !== 0) {
      tripleTees = Math.floor(numberOfTees / 3);
      numberOfTees -= tripleTees * 3;
    }

    const doubleTees = Math.floor(numberOfTees / 2);
    numberOfTees -= doubleTees * 2;

    const singleTees = numberOfTees;  // Leftover tees are single tees

    const manifoldTeeVolume =
      singleTees * manifoldSingleTeeVolume +
      doubleTees * manifoldDoubleTeeVolume +
      tripleTees * manifoldTripleTeeVolume;

    return manifoldTeeVolume;
  }
}

class PipeFitting {
  constructor(id, name, description, isDefault = false) {
    this._id = id;
    this._name = name;
    this._isDefault = isDefault;
    this._description = description;
  }

  get id() {
    return this._id
  }

  get name() {
    return this._name
  }

  get isDefault() {
    return this._isDefault
  }

  get description() {
    return this._description
  }
}

class PipeType {
  constructor(id, name, description, isDefault = false) {
    this._id = id;
    this._name = name;
    this._isDefault = isDefault;
    this._description = description;
  }

  get id() {
    return this._id
  }

  get name() {
    return this._name
  }

  get isDefault() {
    return this._isDefault
  }

  get description() {
    return this._description
  }
}

class PipeSystemType {
  constructor(id, name, description, isDefault = false) {
    this._id = id;
    this._name = name;
    this._isDefault = isDefault;
    this._description = description;
  }

  get id() {
    return this._id
  }

  get name() {
    return this._name
  }

  get isDefault() {
    return this._isDefault
  }

  get description() {
    return this._description
  }
}

class PipePart {
  constructor(type, width, length, tConnections, tDistance, imgType) {
    this._type = type;
    this._width = new InchUtility(width);
    this._length = new InchUtility(length);
    this._tConnections = tConnections;
    this._tDistance = tDistance;
    this._imgType = imgType;
  }

  get type() {
    return this._type;
  }

  get nominalDiamter() {
    return this._nominalDiameter;
  }

  get width() {
    return this._width;
  }

  get length() {
    return this._length;
  }

  get tConnections() {
    return this._tConnections;
  }

  get tDistance() {
    return this._tDistance;
  }

  get imgType() {
    return this._imgType;
  }
}

export class InchUtility {
  constructor(inches) {
    this._inches = inches;
  }

  static fromPixels(px) {
    let oneFeetInPixels = getScaledPixels(1);
    let ft = px / oneFeetInPixels;
    return new InchUtility(ft);
  }

  get in() {
    return this._inches;
  }

  get ft() {
    return this._inches / 12;
  }

  get mm() {
    return this._inches * 25.4;
  }

  get px() {
    return getScaledPixels(this.ft);
  }
}

const dataset = {
  // TODO: Work with Gerardo about how this should look for him
  pipeAccessories: [
    {
      "id": "PIPE_STUB",
      "name": "Stub",
      "description": "ADS stub accessory",
      "type": "pipeAccessory",
      "color": "coral",
      "variant": "default",
      "order": 2,
      "for": {
        "endcaps": false,
        "chambers": false
      },
      "exceptions": {}
    },
    {
      "id": "PIPE_RISER",
      "name": "Riser",
      "description": "ADS riser accessory",
      "type": "pipeAccessory",
      "color": "cornflowerblue",
      "variant": "default",
      "order": 3,
      "for": {
        "endcaps": false,
        "chambers": false
      },
      "exceptions": {}
    },
    {
      "id": "PIPE_CLEANOUT",
      "name": "Cleanout",
      "description": "ADS cleanout accessory",
      "type": "pipeAccessory",
      "color": "aqua",
      "variant": "default",
      "order": 4,
      "for": {
        "endcaps": false,
        "chambers": false
      },
      "exceptions": {}
    },
    {
      "id": "PIPE_INSERTA_TEE",
      "name": "Inserta-tee",
      "description": "ADS inserta-tee accessory",
      "type": "pipeAccessory",
      "color": "greenyellow",
      "variant": "default",
      "order": 5,
      "for": {
        "endcaps": false,
        "chambers": false
      },
      "exceptions": {}
    },
  ],
  pipeSizes: [
      new PipeNominalDiameter(4, 4.1, 4.80, 0.656),
      new PipeNominalDiameter(6, 6, 6.96, 0.774),
      new PipeNominalDiameter(8, 7.9, 9.12, 0.96),
      new PipeNominalDiameter(10, 9.9, 11.40, 1.26),
      new PipeNominalDiameter(12, 12.15, 14.40, 1.954, 5.8997, 236.4717, 12.701, 10.747, 14.655, 8,
          2945.167742, 2492.065013, 3398.270472,
          3819.88092, 7639.761841, 11459.64276,
          3593.32955567563, 7186.65911135126, 10779.9886670269,
          4046.43228526093, 8092.86457052187, 12139.2968557828,
          ALL_PIPE_NOMINAL_DIAMETER_TYPES, true,
          { default: new InchUtility(8), min: new InchUtility(8), max: new InchUtility(99999) },
          null,
          4136.973865,
          5210.132797,
          10420.26559,
          15630.39839),
      new PipeNominalDiameter(15, 14.98, 17.52, 2.627, 7.7808, 236.3298, 14.4485, 11.8215, 17.0755, 8,
          5092.909422, 4166.92589, 6018.892953,
          6518.858945, 13037.71789, 19556.57683,
          6055.86717898716, 12111.7343579743, 18167.6015369615,
          6981.85071016932, 13963.7014203386, 20945.5521305079,
          ALL_PIPE_NOMINAL_DIAMETER_TYPES, false,
          { default: new InchUtility(8), min: new InchUtility(8), max: new InchUtility(99999) },
          null,
          6966.439069,
          8657.068268,
          17314.13654,
          25971.2048),
      new PipeNominalDiameter(18, 18.00, 21.24, 2.94, 7.8804, 234.2604, 17.64, 14.7, 20.58 - 0.000000000000006, 9,
          8977.660007, 7481.383339, 10473.93668,
          11522.49142, 23044.98283, 34567.47425,
          10774.3530815677, 21548.7061631354, 32323.0592447031,
          12270.6297494343, 24541.2594988685, 36811.88924830280000,
          ALL_PIPE_NOMINAL_DIAMETER_TYPES, false,
          { default: new InchUtility(9), min: new InchUtility(9), max: new InchUtility(99999) },
          null,
          12500.50283,
          15556.70003,
          31113.40006,
          46670.10009),
      new PipeNominalDiameter(24, 24.00, 27.84, 2.955, 9.395, 233.975, 20.685, 17.73, 23.64, 10,
          18715.33356, 16041.71448, 21388.95264,
          23465.00367, 46930.00734, 70395.01101,
          22128.1941296377, 44256.3882592754, 66384.582388913,
          24801.8132096351, 49603.6264192703, 74405.4396289054,
          ALL_PIPE_NOMINAL_DIAMETER_TYPES, false,
          { default: new InchUtility(10), min: new InchUtility(10), max: new InchUtility(99999) },
          null,
          25183.37104,
          30582.44779,
          61164.89558,
          91747.34337),
      new PipeNominalDiameter(30, 30.00, 35.16, 4.0804, 10.288, 234.71, 26.5226, 22.4422, 30.603, 18,
          37495.4153, 31726.88987, 43263.94073,
          47243.12945, 94486.2589, 141729.3883,
          44358.8667346888, 88717.7334693773, 133076.600204066,
          50127.3921651145, 100254.784330229, 112486.245893306,
          ALL_PIPE_NOMINAL_DIAMETER_TYPES, false,
          { default: new InchUtility(18), min: new InchUtility(18), max: new InchUtility(99999) },
          null,
          51503.13974,
          62766.14558,
          125532.2912,
          188298.4367),
      new PipeNominalDiameter(36, 36.00, 41.76, 5.247, 10.309, 235.93, 31.482, 26.46995, 36.99895 - 0.5049, 18,
          64089.4994, 53336.6649, 74771.08263,
          80582.26034, 161164.5207, 241746.781,
          75241.4687185876, 150411.686167277, 225617.529250915,
          85923.0519516433, 171846.103903287, 257769.15585493,
          ALL_PIPE_NOMINAL_DIAMETER_TYPES, false,
          { default: new InchUtility(18), min: new InchUtility(18), max: new InchUtility(99999) },
          null,
          86238.89271,
          105083.2845,
          210166.569,
          315249.8535),
      new PipeNominalDiameter(42, 41.4, 47.76, 5.138, 10.578, 236.65, 35.966, 35.966, 35.966, 18,
          96830.54704, 96830.54704, 96830.54704,
          121593.1897, 243186.3793, null,
          121593.189655817, 243186.379311633, null,
          121593.189655817, 243186.379311633, null,
          ALL_PIPE_NOMINAL_DIAMETER_TYPES, false,
          { default: new InchUtility(18), min: new InchUtility(18), max: new InchUtility(99999) },
          null,
          128866.6839,
          156986.2257,
          313972.4514,
          470958.6771),
      new PipeNominalDiameter(48, 47.6, 53.64, 5.233, 11.181, 236.2, 39.2475, 39.2475, 39.2475, 18,
          139683.6153, 139683.6153, 139683.6153,
          173575.3902, 347150.7804, null,
          173575.390185366, 347150.780370733, null,
          173575.390185366, 347150.780370733, null,
          ALL_PIPE_NOMINAL_DIAMETER_TYPES, false,
          { default: new InchUtility(18), min: new InchUtility(18), max: new InchUtility(99999) },
          null,
          177381.9454,
          214627.6952,
          429255.3904,
          643883.0856),
      new PipeNominalDiameter(60, 59.5, 66.36, 6.0027, 13.9801, 236.08, 45.02025, 39.00, 51.02295 + 0.01755, 18,
          250245.3455, 216879.299428038, 250245.34549389,
          305322.0263, 610644.052503718848, null,
          288582.698016198, 577262.991717138, null,
          321948.74408205, 644025.113290302, null,
          ALL_PIPE_NOMINAL_DIAMETER_TYPES, false,
          { default: new InchUtility(18), min: new InchUtility(18), max: new InchUtility(99999) },
          null,
          311415.7218,
          369714.8535,
          739429.707,
          1109144.561),
  ],
  pipeFittings: [
    new PipeFitting(PIPE_TYPE_SOIL_TIGHT_ID, PIPE_TYPE_SOIL_TIGHT_NAME, "ADS Soil-Tight Pipe", true),
    new PipeFitting(PIPE_TYPE_SOIL_TIGHT_PERFORATED_ID, PIPE_TYPE_SOIL_TIGHT_PERFORATED_NAME, "ADS Soil-Tight Perforated Pipe"),
    new PipeFitting(PIPE_TYPE_WATER_TIGHT_ID, PIPE_TYPE_WATER_TIGHT_NAME, "ADS Water-Tight Pipe")
  ],
  pipeTypes: [
    new PipeType(HDPE_N12_ID, HDPE_N12_ID, "HDPE N-12", true)
  ],
  pipeParts: [
    new PipePart(PIPE_PART_CORNER, 12, 12, null, null, 'CORNER'),
    new PipePart(PIPE_PART_MANIFOLD_T, 12, 12, 1, 12, 'SINGLE'),
    new PipePart(PIPE_PART_MANIFOLD_T, 12, 36, 2, 12, 'DOUBLE'),
    new PipePart(PIPE_PART_MANIFOLD_T, 12, 48, 3, 12, 'TRIPLE'),
  ],
  pipeSystemTypes: [
    new PipeSystemType(PIPE_DETENTION_SYSTEM_ID, PIPE_DETENTION_SYSTEM_NAME, "Detention system", true),
    new PipeSystemType(PIPE_CUSTOMF_FITTING_ID, PIPE_CUSTOMF_FITTING_NAME, "Custom fitting", false),
    new PipeSystemType(PIPE_LINE_LAYOUT_ID, PIPE_LINE_LAYOUT_NAME, "Line layout", false),
    new PipeSystemType(PIPE_RETENTION_SYSTEM_ID, PIPE_RETENTION_SYSTEM_NAME, "Retention system", false)
  ],
  pipeFlowDirections: [
      { id: PipeFlowDirection.TopLeftToBottomLeft, name: "Top-left to bottom-left" },
      { id: PipeFlowDirection.TopLeftToBottomRight, name: "Top-left to bottom-right" },
      { id: PipeFlowDirection.TopRightToBottomLeft, name: "Top-right to bottom-left" },
      { id: PipeFlowDirection.TopRightToBottomRight, name: "Top-right to bottom-right" },
      { id: PipeFlowDirection.BottomLeftToTopLeft, name: "Bottom-left to top-left" },
      { id: PipeFlowDirection.BottomLeftToTopRight, name: "Bottom-left to top-right" },
      { id: PipeFlowDirection.BottomRightToTopLeft, name: "Bottom-right to top-left" },
      { id: PipeFlowDirection.BottomRightToTopRight, name: "Bottom-right to top-right" },
  ]
};

// Build interfaces around data
let _pipeSizes = dataset.pipeSizes;
_pipeSizes.sort((a, b) => a.rawPipeND - b.rawPipeND);

export const pipeSizes = {
  default: _pipeSizes.find(_pipeSize => _pipeSize.isDefault),
  dataset: _pipeSizes,
  accessories: _pipeSizes.filter(_pipeSize => _pipeSize.isAccessory),
  sticksOrFittings: _pipeSizes.filter(_pipeSize => _pipeSize.isStick || _pipeSize.isFitting),
  getByNominalDiameter: pipeNominalDiameter => _pipeSizes.find(_pipeSize => _pipeSize.rawPipeND === pipeNominalDiameter)
};

let _pipeTypes = dataset.pipeTypes;
_pipeTypes.sort((a, b) => b.name.toLowerCase() - a.name.toLowerCase());

export const pipeTypes = {
  default: _pipeTypes.find(_pipeType => _pipeType.isDefault),
  dataset: _pipeTypes,
  getById: id => _pipeTypes.find(_pipeType => _pipeType.id === id)
};

let _pipeFittings = dataset.pipeFittings;
_pipeFittings.sort((a, b) => b.name.toLowerCase() - a.name.toLowerCase());

export const pipeFittings = {
  default: _pipeFittings.find(_pipeFitting => _pipeFitting.isDefault),
  dataset: _pipeFittings,
  getById: id => _pipeFittings.find(_pipeFitting => _pipeFitting.id === id)
};

let _pipeSystemTypes = dataset.pipeSystemTypes;
_pipeSystemTypes.sort((a, b) => b.name.toLowerCase() - a.name.toLowerCase());

export const pipeSystemTypes = {
  default: _pipeSystemTypes.find(_pipeSystemType => _pipeSystemType.isDefault),
  dataset: _pipeSystemTypes,
  getById: id => _pipeSystemTypes.find(_pipeSystemType => _pipeSystemType.id === id)
};

let _pipeFlowDirections = dataset.pipeFlowDirections;

export const pipeFlowDirections = {
  dataset: _pipeFlowDirections,
  getById: id => _pipeFlowDirections.find(_pipeFlowDirection => _pipeFlowDirection.id === id)
};

export default dataset;



// WEBPACK FOOTER //
// ./src/lib/pipe-dataset.js